const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

export default function sortByName(items, getName = item => item.name) {
    return items.slice().sort((left, right) => collator.compare(
        String(getName(left) ?? '').trim(),
        String(getName(right) ?? '').trim()
    ));
}
